module.exports = __webpack_public_path__ + "static/FontAwesome5_Brands-c39278f7abfc798a241551194f55e29f.ttf";